import {Alert, Avatar, Checkbox, DatePicker, Input, Radio} from 'antd'
import {getId} from 'apis/model/base'
import DidOnMount from 'components/DidOnMount'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {LoginContext} from 'components/LoginContext'
import Pure from 'components/Pure'
import {Formik, FormikConsumer} from 'formik'
import {getDateString, parseDayjs} from 'helpers/datetimeHelpers'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useContext, useMemo, useState} from 'react'
import {IoCalendarOutline} from 'react-icons/io5'
import {compose, mapProps} from 'recompose'
import {GenderTypes} from 'views/AppLocals/appFieldTypes'
import {gConfigs} from 'views/AppLocals/configs'
import {appClassNames} from 'views/AppLocals/custom/appClassNames'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {NullAsDefault, renderIf} from 'views/Shared'
import CourseContext from '../CourseContext'
import {IdentifierTypes} from "../../appFieldTypes";
import FieldDecorator from "../../../../components/form/FieldDecorator";
import {DynamicFieldsUtilWithRequiredForRegistration} from "../../../../components/DynamicFields/DynamicFieldUtilization";
import {ExtraExpandedButton, HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {BsInfoCircleFill, BsPersonFillCheck} from "react-icons/bs";
import getAvatar from "../../../../helpers/getAvatar";
import {BiSolidChurch} from "react-icons/bi";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import getTitle from "../../../../helpers/getTitle";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import LookupField from "../../../../components/LookupField";
import {MdChurch, MdContactPhone} from "react-icons/md";
import {RiMapPinFill} from "react-icons/ri";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";
import {SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {renderIfElse} from "../../../Shared";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import Toggle from "../../../../components/Toggle";
import {DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import dayjs from "dayjs";


const withEditOptional =
    (field_names = []) =>
        ({form, onChange}) => {
            const {user} = form?.values ?? {}
            const {is_self_reg = 1} = form?.values ?? {}
            const locked = Boolean(
                user && !!is_self_reg &&
                _.some(Array.from(field_names ?? []).map((name) => _.get(user, name, null) !== null))
            )
            if (locked) {
                return {
                    disabled: true,
                    readOnly: true,
                    onChange: undefined,
                }
            } else {
                return {
                    onChange,
                }
            }
        }

export const formSchema = {
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    patron_saint__fullname: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form, ...restForm}) => {

                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose patron saint')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.patron_saint_name}
                                    selectedOption={form?.values?.patron_saint}
                                    apiPath={`/lookup/saint/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<SaintsOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="flex flex-col flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                    {renderIf(
                                                        o?.description,
                                                        <span className="text-xs text-color-400 italic max-lines-1">
                                                        {o?.description}
                                                    </span>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            patron_saint: e.target,
                                            patron_saint_name: e.target.common_name || e.target.value,
                                            patron_saint_feast_day: e.target.feast_day,
                                            patron_saint_id: e.target.id
                                        })
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'fullname',
                name: 'fullname',
                isRequired: true,
                component: ({name, form, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                placeholder={t('Enter your name')}
                                {...{name, value, onChange}}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    fullname: {
        title: 'fullname',
        children: [
            {
                name: 'fullname',
                component: ({name, form, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                placeholder={t('Enter your name')}
                                {...{name, value, onChange}}
                                {...(withEditOptional(['name'])({form, onChange}) ?? {})}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    date_of_birth__gender: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'date of birth',
                name: 'date_of_birth',
                component: compose(
                    withTranslate,
                    mapProps(({name, form, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full custom-date-picker',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: `${translate('date of birth')} "DD/MM/YYYY"`,
                        // 🔹 Giới hạn ngày
                        disabledDate: (current) => {
                            const maxDate = dayjs().subtract(5, 'year');
                            const minDate = dayjs().subtract(120, 'year');

                            return (
                                current &&
                                (current > maxDate.endOf('day') || current < minDate.startOf('day'))
                            );
                        },
                        // 🔹 mở lịch ở khoảng năm hợp lý
                        defaultPickerValue: value ?? dayjs().subtract(30, 'year'),
                        ...(withEditOptional(['date_of_birth'])({
                            form,
                            onChange: (date, dateString) => {
                                onChange(
                                    createValue(name, date ? dayjs(new Date(date)) : null)
                                )
                            },
                        }) ?? {}),
                    }))
                )(DatePicker),
            },
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, form, value, onChange, translate}) => ({
                        name,
                        onChange,
                        defaultValue: Number(value),
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-button',
                        children: Object.values(GenderTypes).map(
                            ({name, value, label}) => (
                                <Radio.Button
                                    key={name}
                                    value={value}>
                                    {translate(label)}
                                </Radio.Button>
                            )
                        ),
                        ...(withEditOptional(['gender'])({
                            form,
                            onChange,
                        }) ?? {}),
                    }))
                )(Radio.Group),
            },
        ],
    },
    phone__email: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'phone',
                name: 'contact_phone',
                component: ({name, form, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                {...{
                                    name,
                                    value,
                                    onChange,
                                }}
                                type="tel"
                                inputMode="tel"
                                placeholder={t('ex: phone')}
                                {...(withEditOptional(['phone_number', 'phone2_number'])({
                                    form,
                                    onChange,
                                }) ?? {})}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'email',
                name: 'contact_email',
                component: ({name, form, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                {...{
                                    name,
                                    value,
                                    onChange,
                                }}
                                type="email"
                                inputMode="email"
                                placeholder={t('ex: email')}
                                {...(withEditOptional(['email'])({form, onChange}) ?? {})}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    identifier: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'identifier type',
                name: 'identifier_type',
                isRequired: true,
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-rounded-md',
                        children: Object.values(IdentifierTypes).map(
                            ({name, value, label}) => (
                                <Radio.Button
                                    style={{padding: '0 8px'}}
                                    key={name}
                                    value={value}>
                                    {translate(label)}
                                </Radio.Button>
                            )
                        ),
                    }))
                )(Radio.Group),
            },
            {
                label: 'identifier code',
                name: 'identifier_code',
                isRequired: true,
                component: createControlledFormField({
                    placeholder: 'identifier code',
                    Component: Input,
                }),
            },
        ],
    },
    metadata: {
        children: [
            {
                name: 'metadata',
                component: ({name, value, onChange}) => (
                    <DynamicFieldsUtilWithRequiredForRegistration
                        name={name}
                        value={value}
                        className="w-full"
                        onChange={(value) => {
                            onChange(createValue(name, value ?? null))
                        }}
                    />
                ),
            },
        ],
    },
    diocese_location: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.parish_name}
                                            selectedOption={form?.values?.parish}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={50}
                                                                src={o.avatar}
                                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                            />
                                                        )}
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                          <span className="font-bold text-sm text-color-000">
                                            {fullname}
                                          </span>
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic leading-snug">
                                            {`( ${diocese_fullname} )`}
                                          </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                {location_address}
                                              </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
    religious_order: {
        inline: true,
        className: 'grid grid-cols-1 gap-3',
        children: [
            {
                label: 'belong to religious order',
                name: 'religious_order',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose religious orders')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.religious_order_name}
                                            selectedOption={form?.values?.religious_order}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/religious_order/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={60}
                                                            src={o.avatar}
                                                            icon={<ReligiousFillSvg size={30}
                                                                                    className="text-color-500"/>}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                        />
                                                        <div className="flex flex-col gap-1 flex-1">
                              <span className="font-bold text-color-000 leading-tight">
                                {o.name}
                              </span>
                                                            {renderIfElse(
                                                                o?.religious_order_group,
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic">
                                    {o?.religious_order_group}
                                  </span>,
                                                                <span
                                                                    className="text-xs text-color-400 italic max-lines-2">
                                    {o?.description}
                                  </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    religious_order: e.target,
                                                    religious_order_name: e.target.value,
                                                    religious_order_id: e.target.id
                                                })
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
}

export const CourseRegisterForm = ({
                                       initialValues,
                                       onCancel = NullAsDefault,
                                       onSubmit = NullAsDefault,
                                   }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [reset_key, set_reset_key] = useState()
    const user = useContext(LoginContext)
    const {item} = useContext(CourseContext);

    const metadata = !!_.get(item, 'metadata')
        ? _.get(item, 'metadata', []).filter(e => !!e.isRequiredForRegistration)
        : [];

    const additional_fields = _.get(item, 'additional_fields', {})

    const validate = (values) => {
        let errors = {}

        const {user, fullname, contact_phone, contact_email, identifier_code, identifier_type, metadata} = values ?? {}

        if (!fullname) {
            errors.fullname = t('required field')
        }

        if (!user && _.isEmpty(contact_phone ?? contact_email ?? '')) {
            errors.contact = t('required field')
        }

        if (!!identifier_code && !identifier_type) {
            errors.identifier = t('required field')
        }

        if (metadata?.length) {
            if (metadata.filter(e => !!!e?.answer_value && !!e?.is_mandatory).length) errors.metadata = t('required field')
        }

        return errors
    }

    const {owner, subjects = [], is_myself_reg} = item ?? {}

    const _initialValues = useMemo(() => {
        const gender = Object.values(GenderTypes).find(({value}) => value == user?.gender)
        const user_info = _.pick(user, [
            'name',
            'gender',
            'email',
            'phone_number',
            'phone2_number',
            'date_of_birth',
            'identifier_code',
            'identifier_type',
            'patron_saint',
            'patron_saint_name',
            'religious_order',
            'religious_order_name',
            'parish',
            'parish_name',
            'diocese',
            'diocese_name',
        ])

        let _values = {
            metadata,
            is_self_reg: is_myself_reg === 0 ? 1 : 0,
            gender: Number(user?.gender),
            user: user_info,
            fullname: user?.name,
            contact_email: user?.email ?? undefined,
            identifier_code: user?.identifier_code ?? undefined,
            identifier_type: user?.identifier_type ?? IdentifierTypes.IdentityCard.value,
            date_of_birth: parseDayjs(user?.date_of_birth),
            contact_phone: user?.phone_number ?? user?.phone2_number ?? undefined,
            subject_ids: _.get(item, 'subjects', []).map(e => {
                return e?.subject?.id
            }),
            religious_order_id: user?.religious_order?.id ?? undefined,
            religious_order_name: user?.religious_order_name ?? undefined,
            religious_order: user?.religious_order ?? undefined,
            patron_saint_id: user?.patron_saint?.id ?? undefined,
            patron_saint_name: user?.patron_saint_name ?? undefined,
            patron_saint: user?.patron_saint ?? undefined,
            parish_id: user?.parish?.id ?? undefined,
            parish_name: user?.parish_name ?? undefined,
            parish: user?.parish ?? undefined,
            diocese_id: user?.diocese?.id ?? undefined,
            diocese_name: user?.diocese_name ?? undefined,
            diocese: user?.diocese ?? undefined,
            ...(initialValues ?? {}),
        }

        if (!!is_myself_reg) {
            _values = {
                ..._values,
                is_self_reg: 0,
                gender: undefined,
                fullname: undefined,
                identifier_code: undefined,
                identifier_type: IdentifierTypes.IdentityCard.value,
                date_of_birth: undefined,
                religious_order_id: undefined,
                religious_order_name: undefined,
                religious_order: undefined,
                patron_saint_id: undefined,
                patron_saint_name: undefined,
                patron_saint: undefined,
            }
        }

        return _values
    }, [user, initialValues])

    return (
        <Formik
            validate={validate}
            onReset={() => {
                set_reset_key(Date.now())
            }}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {user, ready, gender, date_of_birth, metadata, subject_ids, religious_order, ...rest} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            metadata: JSON.stringify(metadata),
                            user_id: getId(user),
                            date_of_birth: getDateString(date_of_birth),
                            gender: gender ? Number(gender) : undefined,
                            subject_ids: subject_ids ? subject_ids.join(",") : undefined
                        },
                        _.isUndefined
                    )
                )
            }}>
            <div className="flex flex-col gap-3">
                <div className="flex items-center gap-3 border border-color-50 shadow-md rounded-lg">
                    <Avatar
                        size={isSm ? 70 : 80}
                        src={getAvatar(owner)}
                        icon={<BiSolidChurch size={50} className="text-primary-300"/>}
                        className="flex flex-center bg-primary-50 rounded-l-lg rounded-r-0"
                    />
                    <div className="flex flex-col gap-1 flex-1">
                        <div className="font-bold text-sm text-green-700 tracking-wide">
                            {item?.title}
                        </div>
                        <ItemInformation
                            className="text-2xs md:text-xs leading-snug"
                            label="organized by"
                            value={
                                <Link to={getLinkToDetail(owner)}
                                      className="font-bold text-2xs md:text-xs text-color-000 no-underline">
                                    {getTitle(owner)}
                                </Link>
                            }
                        />
                        {renderIf(
                            _.some([item?.time_open, item?.time_close]),
                            <DoubleValueItem
                                labelFirst="time"
                                valueFirst={formatSimplifyDate(item?.time_open)}
                                labelSecond={item?.time_close ? ' - ' : ''}
                                valueSecond={item?.time_close ? formatSimplifyDate(item?.time_close) : ''}
                                className="text-xs italic leading-tight"
                            />
                        )}
                    </div>
                </div>
                <FormikConsumer>
                    {({values, setValues, errors, handleChange}) => {
                        return (
                            <div className="mt-3 mb-1 flex flex-col md:flex-row md:items-center gap-2">
                                <div className="flex flex-col flex-1">
                                    <div className="flex items-center gap-2 flex-1">
                                        <BsPersonFillCheck size={18} className="text-blue-400"/>
                                        <span className="font-medium text-sm text-blue-700 tracking-wide">
                                            {t('who is this course registration for')}
                                        </span>
                                    </div>
                                    {renderIfElse(
                                        is_myself_reg === 1,
                                        <span className="ml-6 text-xs text-orange-400 italic leading-snug">
                                            {t('registration this course description')}
                                        </span>,
                                        <span className="mt-1 text-xs text-color-400 italic leading-snug">
                                            {`* ${t('registration this course description default')}`}
                                        </span>
                                    )}
                                </div>
                                <FieldDecorator key="is_self_reg" errors={errors["is_self_reg"]}>
                                    <Radio.Group
                                        defaultValue={!!is_myself_reg ? 0 : 1}
                                        name="is_self_reg"
                                        className="flex flex-row md:flex-col gap-x-3 gap-y-1 ml-3 md:ml-0"
                                        onChange={(event) => {
                                            const {name, value} = event.target
                                            let _values = {};
                                            if (value === 1) {
                                                _values = {
                                                    ...values,
                                                    is_self_reg: 1,
                                                    gender: user?.gender ?? undefined,
                                                    fullname: user?.name ?? undefined,
                                                    contact_email: user?.email ?? undefined,
                                                    identifier_code: user?.identifier_code ?? undefined,
                                                    identifier_type: user?.identifier_type ?? IdentifierTypes.IdentityCard.value,
                                                    date_of_birth: parseDayjs(user?.date_of_birth),
                                                    contact_phone: user?.phone_number ?? user?.phone2_number ?? undefined,
                                                    religious_order_id: user?.religious_order?.id ?? undefined,
                                                    religious_order_name: user?.religious_order_name ?? undefined,
                                                    religious_order: user?.religious_order ?? undefined,
                                                    patron_saint_id: user?.patron_saint?.id ?? undefined,
                                                    patron_saint_name: user?.patron_saint_name ?? undefined,
                                                    patron_saint: user?.patron_saint ?? undefined,
                                                    parish_id: user?.parish?.id ?? undefined,
                                                    parish_name: user?.parish_name ?? undefined,
                                                    parish: user?.parish ?? undefined,
                                                    diocese_id: user?.diocese?.id ?? undefined,
                                                    diocese_name: user?.diocese_name ?? undefined,
                                                    diocese: user?.diocese ?? undefined,
                                                }
                                            } else {
                                                _values = {
                                                    ...values,
                                                    is_self_reg: 0,
                                                    gender: undefined,
                                                    fullname: undefined,
                                                    identifier_code: undefined,
                                                    identifier_type: IdentifierTypes.IdentityCard.value,
                                                    date_of_birth: undefined,
                                                    religious_order_id: undefined,
                                                    religious_order_name: undefined,
                                                    religious_order: undefined,
                                                    patron_saint_id: undefined,
                                                    patron_saint_name: undefined,
                                                    patron_saint: undefined,
                                                    parish_id: undefined,
                                                    parish_name: undefined,
                                                    parish: undefined,
                                                    diocese_id: undefined,
                                                    diocese_name: undefined,
                                                    diocese: undefined,
                                                }
                                            }
                                            setValues({
                                                ..._values
                                            });
                                        }}>
                                        <Radio disabled={!!is_myself_reg} value={1}
                                               className="font-medium italic">{t('yourself')}</Radio>
                                        <Radio value={0} className="font-medium italic">{t('someone else')}</Radio>
                                    </Radio.Group>
                                </FieldDecorator>
                            </div>
                        )
                    }}
                </FormikConsumer>
                <Pure>
                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col gap-2">
                            <HeaderWithIconLine
                                icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                                title="personal information"
                                className="text-base text-color-300"
                            />
                            <FieldsFactory
                                formSchema={[
                                    formSchema.patron_saint__fullname,
                                    formSchema.identifier,
                                    formSchema.date_of_birth__gender,
                                ]}
                            />
                            <div className="mt-1 text-sm text-orange-400 italic">
                                {`* ${t('required information')}`}
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            <HeaderWithIconLine
                                icon={<MdContactPhone size={14} className="text-color-500 mr-1"/>}
                                title="contact"
                                className="text-base text-color-300"
                            />
                            <FieldsFactory
                                formSchema={[
                                    formSchema.phone__email,
                                    formSchema.diocese_location
                                ]}
                            />
                            {renderIf(
                                !!_.get(additional_fields, 'religious_order'),
                                <FieldsFactory formSchema={[formSchema.religious_order]}/>
                            )}
                        </div>

                        {renderIf(
                            metadata?.length,
                            <Toggle defaultValue={true}>
                                {(isToggle, toggle) => (
                                    <div className="flex flex-col gap-2">
                                        <HeaderWithIconLine
                                            icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                                            title="additional information"
                                            className="text-base text-color-300"
                                            extra={
                                                <ExtraExpandedButton isToggle={isToggle} toggle={toggle}/>
                                            }
                                        />
                                        {isToggle && (
                                            <Pure>
                                                <div className="ml-2 flex flex-col gap-2">
                                                    <FieldsFactory formSchema={[formSchema.metadata]}/>
                                                </div>
                                            </Pure>
                                        )}
                                    </div>
                                )}
                            </Toggle>
                        )}
                        {renderIf(
                            subjects.length > 0,
                            <Toggle defaultValue={true}>
                                {(isToggle, toggle) => (
                                    <FormikConsumer>
                                        {({values, errors, handleChange}) => (
                                            <div className="flex flex-col gap-2">
                                                <HeaderWithIconLine
                                                    icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                                                    title="choose subject"
                                                    className="text-base text-color-300"
                                                    extra={
                                                        <ExtraExpandedButton isToggle={isToggle} toggle={toggle}/>
                                                    }
                                                />
                                                {isToggle && (
                                                    <FieldDecorator key="subject_ids" errors={errors["subject_ids"]}>
                                                        <Checkbox.Group
                                                            className="ml-2 grid grid-cols-2 gap-2"
                                                            name="subject_ids"
                                                            options={_.get(item, 'subjects', []).map(e => {
                                                                return {value: e?.subject?.id, label: e?.subject?.title}
                                                            })}
                                                            defaultValue={values.subject_ids}
                                                            onChange={e => {
                                                                handleChange(createValue('subject_ids', e))
                                                            }}
                                                        />
                                                    </FieldDecorator>
                                                )}
                                            </div>
                                        )}
                                    </FormikConsumer>
                                )}
                            </Toggle>
                        )}


                        <FormikConsumer>
                            {({errors, handleChange}) => (
                                <React.Fragment>
                                    <Pure input={[user, reset_key]}>
                                        <DidOnMount
                                            key={[user, reset_key]}
                                            handler={() => {
                                                if (user) {
                                                    handleChange(createValue('ready', true))
                                                }
                                            }}
                                        />
                                    </Pure>
                                    {renderIf(
                                        errors?.contact,
                                        <Alert type="error" closable={true} message={<span
                                            className="font-xs">{t('either email or phone is required')}</span>}/>
                                    )}
                                </React.Fragment>
                            )}
                        </FormikConsumer>

                        <div className="p-2 bg-orange-50 rounded-md text-sm text-orange-400 italic leading-tight">
                            {`* ${t('required information')}`}
                        </div>
                        <FormActionBar submitText="register"/>
                    </div>
                </Pure>
            </div>
        </Formik>
    )
}
